
import React, { useMemo } from 'react'
import { ensureHexFormat } from 'smartstream-widgets/utils/colors'
import { compose } from 'widgets-shared/core'
import { withComponentContext } from 'widgets-shared/core'

import { Props } from './types'
import { Competitor, CompetitorBrand } from "smartstream-widgets/types/competitor"
import DynamicImage from '../DynamicImage/DynamicImage'

function TeamLogo(props: Props) {
  const {
    className = '',
    config: {
      BASE_ASSET_PATH = '',
      useAlternateLogos
    },
    competitor = {} as Competitor,
    competitionId = ''
  } = props

  const motorSportCompetitions = ['635']
  const isMotorSport = motorSportCompetitions.includes(competitionId)
  const defaultImageUrl = `${BASE_ASSET_PATH}/img/${isMotorSport ? 'defaultUserLogo' : 'defaultLogo'}.svg`
  const { brand = {} as CompetitorBrand } = competitor
  const teamValues = useMemo(() => ({
    logo: (brand && brand.logo && (brand.logo.svg || brand.logo.x1)) || defaultImageUrl,
    primaryColor: ensureHexFormat(brand.primaryColor) || '#D4D8D8',
    secondaryColor: ensureHexFormat(brand.secondaryColor) || '#A8ADB7',
    name: competitor.officialName || ''
  }), [competitor])

  return (
    useAlternateLogos && !isMotorSport ?
      <svg className={className} viewBox='0 0 24 26' xmlns='http://www.w3.org/2000/svg' >
        <path
          d='M12.92 25.08c-.3.12-.6.18-.92.18V0c.32 0 .63.06.92.18l9.6 3.95c.9.37 1.48 1.23 1.48 2.19 0 10.91-6.8 17-11.08 18.76z'
          fill={teamValues.primaryColor} />
        <path
          d='M12 0v25.26c-.32 0-.63-.06-.93-.18C5.72 22.88 0 16.11 0 6.32c0-.96.58-1.82 1.48-2.2l9.6-3.94c.3-.12.6-.18.92-.18z'
          fill={teamValues.secondaryColor} />
      </svg>
      :
      <DynamicImage supportedFormats={['webp']}>
        <img src={teamValues.logo} className={className} alt={teamValues.name} />
      </DynamicImage>
  )
}

export default compose(
  withComponentContext,
)(TeamLogo)
